import { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

//-
import {
    Home,
    Dashboard,
    NotFound,
    CommentList,
    CommentDetail,
    CommentTicket,
    CommentRejectReason,
    CacheManagement,
    MenuManagement,
    AuthorizationRuleManagement,
    AuthorizationManage,
    ListUserRoles,
    EditUser,
    EditRoles,
    StoreLcwaikikiV2,
    PaymentLogs,
    ShippingCompanyRequest,
    MPPrepareReturnToSellerList,
    CacheTeam,
    DesignCollective,
    MpConfig,
    MpApplicationHandler,
    StorePickUp,
    StoreReturn,
    StoreList,
    LcwMoney,
    BillingService,
    BillingGoal,
    FailedInvoice,
    MenuManagementAll,
    ReturnList,
    ReturnRejectEntegration,
    CreateReturn,
    Refund,
    RefundV2,
    BillingErrorLog,
    BillingQuery,
    SsrsPage,
    SsrsPageManagement,
    OFSLogs,
    OrderFraudControl,
    SmsTemplate,
    LocalizationManagement,
    ProductSearch,
    ProductDetail,
    CargoManagement,
    CargoManagementV2,
    EmailTemplateBuilder,
    SectionGallery,
    TemplateGallery,
    RPAResend,
    AutoReturnAndResend,
    RpaRequestManagement,
    AddSection,
    EditSection,
    PetitionRefundList,
    PetitionRefundListV2,
    ReturnDetailV2,
    MpClientTranslations,
    ScheduleService,
    EstimatedShippingDate,
    GlobalData,
    GlobalDataCacheManagement,
    MasterData,
    GoalStatusSending,
    AddJsonTemplate,
    EditJsonTemplate,
    StorePickupPackage,
    Summary,
    SummaryV2,
    NetSales,
    SaSummaryList,
    SaSummaryDetailSearch,
    FastDeliveryCargoManagement,
    RedisCacheManagement,
    NoOrderShotSearch,
    ProductShotHistory,
    PendingRoleRequests,
    RequestRole,
    MyRoleRequests,
    HiddenExcel,
    BinNumberManagement,
    FinanceReport,
    IpWhiteList,
    SyncTableState,
    CutOff,
    CargoAddressBlocking,
    StoreCargoBlocking,
    OTPPassword,
    MembershipSmsManagement,
    Mannequin,
    MannequinFormWrapper,
    AIGenerationPage,
    AIGenerationTypeSelectorPage,
    AIStudioAnalytics,
    ProductGenerationReport,
    CargoCompanyDistributionAreas,
    AIPromptManagement,
    AIPromptS3BrowserTest,
    S3Browser,
    TaskAnalyzer,
    CustomerDiagnostics,
    CardBalanceInquiry,
    DailyPlanner,
    StoreCustomerManagement,
    StoreCustomerLegacyUrlRedirect,
    EtbisReports,
    StaffPermissions,
    PermissionHistory,
    MobileProductCapture,
    ReturnIpLogReport,
    RetroBoard,
} from '../../pages';
import { StudioPromptList } from '../../pages_studio/page/StudioPrompt/StudioPromptList';
import { AIGenerationHistoryPage } from '../../pages/Mannequin/AIGenerationHistoryPage';

import { Template, InstallmentOptionManagement } from '../../pages_ro';
import { CargoShippingManagement } from '../../pages_ru';
import { CampaignManagement } from '../../pages_ua';
import JsonTemplate from '../../pages/DynamicJsonBuilder/JsonTemplate';

import { PageUrl } from '../../types/enums/pageUrl-enums';
import { PageUrlRo } from '../../types/enums/pageUrlRo-enums';
import { PageUrlRu } from '../../types/enums/pageUrlRu-enums';
import { PageUrlUa } from '../../types/enums/pageUrlUa-enums';
import { PageUrlYdMp } from '../../types/enums/pageUrlYdMp-enums';

import { AuthenticatedRoute, AuthorizedRoute } from '../../atomic/shared';
import { SCUIPage } from '../../atomic/templates';
import { TransferCargoData } from '../../pages/TransferCargoData';
import { StoreReturnSearch } from '../../pages/StoreReturnSearch';
import { ServiceManagment } from '../../pages/ServiceManagment';
import { ShippingPerformance } from '../../pages/ShippingPerformance';
import { SearchService } from '../../pages/SearchService';
import { Orders } from '../../pages/Orders';
import { RetailDb } from '../../pages/RetailDb';
import { MpApplicationHandlerV2 } from '../../pages/MpApplicationHandlerV2';
import { MpConfigV2 } from '../../pages/MpConfigV2';
import {
    RuntimeConfigurationList,
    RuntimeConfigurationCreate,
    RuntimeConfigurationDetail,
} from '../../pages/RuntimeConfiguration';
import { DetailStockSearch } from '../../pages/DetailStockSearch';
import { ProductTransfer } from '../../pages/ProductTransfer';
import { EmailAndSmsServiceLogs } from '../../pages/EmailAndSmsServiceLogs';
import { OrderNotFinance } from '../../pages/OrderNotFinance';
import { ProductDashboard } from '../../pages/ProductDashboard';
import { RefundProcessNo } from '../../pages/RefundProcessNo';
import { StoreCustomerService } from '../../pages/StoreCustomerService/StoreCustomerService';
import { CustomerManagement } from '../../pages/CustomerManagement/CustomerManagement';
import { ImageSearch } from '../../pages/ImageSearch';
import { ImageSearchV2 } from '../../pages/ImageSearchV2';
import { GreetingNotes } from '../../pages/GreetingNotes/GreetingNotes';
import { CargoFeeManagement } from '../../pages/CargoFeeManagement';
import { RefundListV2 } from '../../pages/RefundListV2';
import { RptTopicManagement } from '../../pages/RptTopicManagement/RptTopicManagement';
import { AkbankTransactionStatusList } from '../../pages/AkbankTransactionStatusList';

import DynamicRequest from '../../pages/DynamicRequest/DynamicRequest';
import { RuleService } from '../../pages/RuleService';
import { RuleServiceV2 } from '../../pages/RuleServiceV2';
import CreateTemplate from '../../pages/EmailTemplateBuilder/CreateTemplate/CreateTemplate';
import { MobileFieldCargoDistribution } from '../../pages/MobileFieldCargoDistribution/MobileFieldCargoDistribution';
import { SendTestMail } from '../../pages/EmailTemplateBuilder/SendTestMail/SendTestMail';
import OrderDetail from '../../pages/OrderDetail/OrderDetail';
import { CampaignManagementSave } from '../../pages_ua/Campaign/CampaignManagementSave';
import { ShippingCancelReason } from '../../pages/ShippingCancelReason';
import { CustomerCommentApprovalPage } from '../../pages/CustomerCommentApprovalPage';
import { CustomerAnonymization } from '../../pages/CustomerAnonymization/CustomerAnonymization';
import { CustomerAnonymizationHistory } from '../../pages/CustomerAnonymization/CustomerAnonymizationHistory';
import { YdRefund } from '../../pages_ydmp/RefundYdMp';
import { MpLabelPrint } from '../../pages_ydmp/MpLabelPrint';
import ShippingListStatusManagement from '../../pages/ShippingListStatusManagement/ShippingListStatusManagement';
import TestServicesUrl from '../../pages/TestServicesUrl/TestServicesUrl';
import { StoreDeliveryOrders } from '../../pages/StoreDeliveryOrders';
import { CampaignManagementMatrix } from '../../pages_ua/Campaign/CampaignManagementMatrix';
import { CookieManagement } from '../../pages/CookieManagement';
import { CookieType } from '../../pages/CookieType';
import ReturnStatusManagement from '../../pages/Return/ReturnStatusManagement/ReturnStatusManagement';
import ProductCommentListV2 from '../../atomic/molecules/SCUIProductCommentDetailForm/components/ProductCommentListV2';
import { DigitalCard } from '../../pages/DigitalCard/DigitalCard';
import ExpenseNote from '../../pages/ExpenseNote/ExpenseNote';
import { GlobalDataTokenManagement } from '../../pages/SiteManagement/GlobalDataTokenManagement/GlobalDataTokenManagement';
import CargoPrioritization from '../../pages/CargoPrioritization/CargoPrioritization';
import PaymentConsolidation from '../../pages/PaymentConsolidation/PaymentConsolidation';
import MobileExpressFraud from '../../pages/MobileExpressFraud/MobileExpressFraud';
import { ShippingCompanyLabel } from '../../pages/ShippingCompanyLabel';
import { ScheduleGroups } from '../../pages/ScheduleGroups/ScheduleGroup';
import { GroupUser } from '../../pages/ScheduleGroups/GroupUser';
import { OrderPrio } from '../../pages/OrderPrio';
import { PageUrlRs } from '../../types/enums';
import { PendingShipmentsPage } from '../../pages_rs';
import { LostCargo } from '../../pages/LostCargo';
import { FiscalPage } from '../../pages_rs/FiscalPage/FiscalPage';
import { CustomerPasswordChange } from '../../pages/CustomerPasswordChange/CustomerPasswordChange';
import LostCargoReturnPageLayout from '../../pages/LostCargoSearchReturnPage/components/LostCargoReturnPageLayout';
import LostCargoReturnDetailPageLayout from '../../pages/LostCargoReturnDetailPage/components/LostCargoReturnDetailPageLayout';
// Studio Routes
import {
    ItemAcceptanceCancellation,
    PlanningDetail,
    PlanningList,
    FileManager,
    GRPCFileManager,
    LegacyTransferImport,
    BackgroundLabelManagement,
    AIGenerationTypeManagement,
    StudioAddressBarcodeManagement,
    StudioAddressBarcodeInformation,
    StudioShotReport,
    StudioProductStatusFlowReport,
    MatchingSetPendingReport,
    PendingRetouchTransfers,
    BulkImageUpload,
    RawImageFrameControl,
    BatchOutputControl,
    BatchProcessTracking,
    BarcodeProductionHistory,
    Retouch,
} from '../../pages_studio';
import { LCWCargoFeeManagement } from '../../pages/LCWCargoFeeManagement';
import { MPCargoFeeManagement } from '@/pages/MPCargoFeeManagement';
import { MPBulkShipmentUpdate } from '@/pages/MPBulkShipmentUpdate';
import { MPPaymentOnDeliveryCommission } from '@/pages/MPPaymentOnDeliveryCommission';
import { GrowManagement } from '@/pages/GrowManagement/GrowManagement';
import { GrowCategoryRestriction } from '@/pages/GrowCategoryRestriction/GrowCategoryRestriction';
import { GrowWorkingDays } from '@/pages/GrowWorkingDays/GrowWorkingDays';
import { AuditLogs } from '@/pages/AuditLogs';
import { CargoReconciliationIFrame } from '@/pages/CargoReconciliationIFrame/CargoReconciliationIFrame';
import { PostCheckoutInsights } from '@/pages/PostCheckoutInsights/PostCheckoutInsights';
import { Paylens } from '@/pages/Paylens/Paylens';
import { PaylensPayment } from '@/pages/PaylensPayment/PaylensPayment';
import { CustomerCommunicationPrefrencesReport } from '@/pages/CustomerCommunicationPrefrencesReport/CustomerCommunicationPrefrencesReport';

export default function MainRouter() {
    return (
        <div>
            <Router>
                <Suspense fallback={<div></div>}>
                    <SCUIPage />
                    <Switch>
                        <Redirect exact from="/" to={PageUrl.home.url} />
                        <AuthorizedRoute path={PageUrl.petition.url} Component={PetitionRefundList} />
                        <AuthorizedRoute path={PageUrl.petitionV2.url} Component={PetitionRefundListV2} />
                        <AuthorizedRoute path={PageUrl.dashboard.url} Component={Dashboard} />
                        <AuthorizedRoute path={PageUrl.home.url} Component={Home} />
                        <AuthorizedRoute path={PageUrl.commentDetail.url} Component={CommentDetail} />
                        <AuthorizedRoute path={PageUrl.commentTicket.url} Component={CommentTicket} />
                        <AuthorizedRoute path={PageUrl.commentRejectReason.url} Component={CommentRejectReason} />
                        <AuthorizedRoute path={PageUrl.cacheManagement.url} Component={CacheManagement} />
                        <AuthorizedRoute path={PageUrl.commentList.url} Component={CommentList} />
                        <AuthorizedRoute path={PageUrl.menuManagement.url} Component={MenuManagement} />
                        <AuthorizedRoute path={PageUrl.authorizationManage.url} Component={AuthorizationManage} />
                        <AuthorizedRoute path={PageUrl.listUserRoles.url} Component={ListUserRoles} />
                        <AuthorizedRoute
                            path={PageUrl.authorizationRuleManagement.url}
                            Component={AuthorizationRuleManagement}
                        />
                        <AuthorizedRoute path={PageUrl.editUser.url} Component={EditUser} />
                        <AuthorizedRoute path={PageUrl.editRoles.url} Component={EditRoles} />
                        <AuthorizedRoute path={PageUrl.storeLcWaikikiV2.url} Component={StoreLcwaikikiV2} />
                        <AuthorizedRoute path={PageUrl.designCollective.url} Component={DesignCollective} />
                        <AuthorizedRoute path={PageUrl.storePickUp.url} Component={StorePickUp} />
                        <AuthorizedRoute path={PageUrl.storeReturn.url} Component={StoreReturn} />
                        <AuthorizedRoute path={PageUrl.storeList.url} Component={StoreList} />
                        <AuthorizedRoute path={PageUrl.mpConfig.url} Component={MpConfig} />
                        <AuthorizedRoute path={PageUrl.mpConfigV2.url} Component={MpConfigV2} />
                        <AuthorizedRoute
                            path={PageUrl.runtimeConfigurationCreate.url}
                            Component={RuntimeConfigurationCreate}
                        />
                        <AuthorizedRoute
                            path={`${PageUrl.runtimeConfigurationDetail.url}/:key`}
                            Component={RuntimeConfigurationDetail}
                        />
                        <AuthorizedRoute exact path={PageUrl.runtimeConfiguration.url} Component={RuntimeConfigurationList} />
                        <AuthorizedRoute path={PageUrl.mpApplicationHandler.url} Component={MpApplicationHandler} />
                        <AuthorizedRoute path={PageUrl.mpApplicationHandlerV2.url} Component={MpApplicationHandlerV2} />
                        <AuthorizedRoute path={PageUrl.mpClientTranslations.url} Component={MpClientTranslations} />
                        <AuthorizedRoute path={PageUrl.cacheTeam.url} Component={CacheTeam} />
                        <AuthorizedRoute path={PageUrl.detailStockSearch.url} Component={DetailStockSearch} />
                        <AuthorizedRoute path={PageUrl.shippingCompanyRequest.url} Component={ShippingCompanyRequest} />
                        <AuthorizedRoute
                            path={PageUrl.MPPrepareReturnToSellerList.url}
                            Component={MPPrepareReturnToSellerList}
                        />
                        <AuthorizedRoute path={PageUrl.billingService.url} Component={BillingService} />
                        <AuthorizedRoute path={PageUrl.ofsLogs.url} Component={OFSLogs} />
                        <AuthorizedRoute path={PageUrl.refund.url} Component={Refund} />
                        <AuthorizedRoute path={PageUrl.refundV2.url} Component={RefundV2} />
                        <AuthorizedRoute path={PageUrl.scheduleGroups.url} Component={ScheduleGroups} />
                        <AuthorizedRoute path={PageUrl.userGroup.url} Component={GroupUser} />
                        <AuthorizedRoute path={PageUrl.returnList.url} Component={ReturnList} />
                        <AuthorizedRoute
                            path={PageUrl.returnRejectEntegration.url}
                            Component={ReturnRejectEntegration}
                        />
                        <AuthorizedRoute path={PageUrl.returnDetail.url} Component={ReturnDetailV2} />
                        <AuthorizedRoute path={PageUrl.returnDetailV2.url} Component={ReturnDetailV2} />
                        <AuthorizedRoute path={PageUrl.returnStatusManagement.url} Component={ReturnStatusManagement} />
                        <AuthorizedRoute path={PageUrl.createReturn.url} Component={CreateReturn} />
                        <AuthorizedRoute path={PageUrl.billingGoal.url} Component={BillingGoal} />
                        <AuthorizedRoute path={PageUrl.billingQuery.url} Component={BillingQuery} />
                        <AuthorizedRoute path={PageUrl.productTransfer.url} Component={ProductTransfer} />
                        <AuthorizedRoute path={PageUrl.ssrsPage.url} Component={SsrsPage} />
                        <AuthorizedRoute path={PageUrl.ssrsPageManagement.url} Component={SsrsPageManagement} />
                        <AuthorizedRoute path={PageUrl.smsTemplate.url} Component={SmsTemplate} />
                        <AuthorizedRoute path={PageUrl.failedInvoice.url} Component={FailedInvoice} />
                        <AuthorizedRoute path={PageUrl.searchService.url} Component={SearchService} />
                        <AuthorizedRoute path={PageUrl.transferCargoData.url} Component={TransferCargoData} />
                        <AuthorizedRoute path={PageUrl.serviceManagment.url} Component={ServiceManagment} />
                        <AuthorizedRoute path={PageUrlRo.template.url} Component={Template} />
                        <AuthorizedRoute path={PageUrl.billingErrorLog.url} Component={BillingErrorLog} />
                        <AuthorizedRoute path={PageUrlRu.cargo.url} Component={CargoShippingManagement} />
                        <AuthorizedRoute path={PageUrl.orderFraudControl.url} Component={OrderFraudControl} />
                        <AuthorizedRoute path={PageUrl.localizationManagement.url} Component={LocalizationManagement} />
                        <AuthorizedRoute path={PageUrl.productSearch.url} Component={ProductSearch} />
                        <AuthorizedRoute path={PageUrl.productDetail.url} Component={ProductDetail} />
                        <AuthorizedRoute path={PageUrl.orderNotFinance.url} Component={OrderNotFinance} />
                        <AuthorizedRoute path={PageUrlRo.installment.url} Component={InstallmentOptionManagement} />
                        <AuthorizedRoute path={PageUrlUa.campaign.matrix.url} Component={CampaignManagementMatrix} />
                        <AuthorizedRoute path={PageUrlUa.campaign.save.url} Component={CampaignManagementSave} />
                        <AuthorizedRoute path={PageUrlUa.campaign.list.url} Component={CampaignManagement} />
                        <AuthorizedRoute path={PageUrl.productDashboard.url} Component={ProductDashboard} />
                        <AuthorizedRoute path={PageUrl.refundProcessNo.url} Component={RefundProcessNo} />
                        <AuthorizedRoute path={PageUrl.cargoManagement.url} Component={CargoManagement} />
                        <AuthorizedRoute path={PageUrl.cargoManagementV2.url} Component={CargoManagementV2} />
                        <AuthorizedRoute path={PageUrl.customerManagement.url} Component={CustomerManagement} />
                        <AuthorizedRoute path={PageUrl.imageSearch.url} Component={ImageSearch} />
                        <AuthorizedRoute path={PageUrl.imageSearchV2.url} Component={ImageSearchV2} />
                        <AuthorizedRoute path={PageUrl.greetingNotes.url} Component={GreetingNotes} />
                        <AuthorizedRoute path={PageUrl.cargoFeeManagement.url} Component={CargoFeeManagement} />
                        <AuthorizedRoute path={PageUrl.estimatedShippingDate.url} Component={EstimatedShippingDate} />
                        {/* EMailTemplateBuilder Start*/}
                        <AuthorizedRoute
                            exact
                            path={PageUrl.emailTemplateBuilder.url}
                            Component={EmailTemplateBuilder}
                        />
                        <AuthorizedRoute path={PageUrl.sectionGallery.url} Component={SectionGallery} />
                        <AuthorizedRoute path={PageUrl.templateGallery.url} Component={TemplateGallery} />
                        <AuthorizedRoute path={PageUrl.addSection.url} Component={AddSection} />
                        <AuthorizedRoute path={PageUrl.editSection.url} Component={EditSection} />
                        <AuthorizedRoute path={PageUrl.createTemplate.url} Component={CreateTemplate} />
                        <AuthorizedRoute path={PageUrl.sendTestMail.url} Component={SendTestMail} />
                        {/* EMailTemplateBuilder End */}
                        <AuthorizedRoute path={PageUrl.orderDetail.url} Component={OrderDetail} />
                        <AuthorizedRoute
                            path={PageUrl.shippingListStatusManagement.url}
                            Component={ShippingListStatusManagement}
                        />
                        <AuthorizedRoute path={PageUrl.globalData.url} Component={GlobalData} />
                        <AuthorizedRoute
                            path={PageUrl.globalDataCacheManagement.url}
                            Component={GlobalDataCacheManagement}
                        />
                        <AuthorizedRoute path={PageUrl.masterData.url} Component={MasterData} />
                        <AuthorizedRoute path={PageUrl.refundlistV2.url} Component={RefundListV2} />
                        <AuthorizedRoute path={PageUrl.ruleService.url} Component={RuleService} />
                        <AuthorizedRoute path={PageUrl.ruleServiceV2.url} Component={RuleServiceV2} />
                        <AuthorizedRoute path={PageUrl.scheduleService.url} Component={ScheduleService} />
                        <AuthorizedRoute path={PageUrl.dynamicRequest.url} Component={DynamicRequest} />
                        <AuthorizedRoute path={PageUrl.orders.url} Component={Orders} />
                        <AuthorizedRoute path={PageUrl.lcwMoney.url} Component={LcwMoney} />
                        <AuthorizedRoute path={PageUrl.emailAndSmsServiceLogs.url} Component={EmailAndSmsServiceLogs} />
                        <AuthorizedRoute path={PageUrl.menuManagementAll.url} Component={MenuManagementAll} />
                        <AuthorizedRoute path={PageUrl.testServicesUrl.url} Component={TestServicesUrl} />
                        <AuthorizedRoute path={PageUrl.retailDb.url} Component={RetailDb} />
                        <AuthorizedRoute path={PageUrl.storeCustomerService.url} Component={StoreCustomerService} />
                        <AuthorizedRoute
                            path={PageUrl.storeCustomerManagement.url}
                            Component={StoreCustomerManagement}
                        />
                        <AuthorizedRoute
                            path={PageUrl.storeCustomerOrderManagement.url}
                            Component={StoreCustomerLegacyUrlRedirect}
                        />
                        <AuthorizedRoute path={PageUrl.shippingPerformance.url} Component={ShippingPerformance} />
                        <AuthorizedRoute path={PageUrl.RPAResend.url} Component={RPAResend} />
                        <AuthorizedRoute path={PageUrl.autoReturnAndResend.url} Component={AutoReturnAndResend} />
                        <AuthorizedRoute path={PageUrl.RpaRequestManagement.url} Component={RpaRequestManagement} />
                        <AuthorizedRoute
                            path={PageUrl.mobileFieldCargoDistribution.url}
                            Component={MobileFieldCargoDistribution}
                        />
                        <AuthorizedRoute path={PageUrl.shippingCancelReason.url} Component={ShippingCancelReason} />
                        <AuthorizedRoute
                            path={PageUrl.customerCommentApprovalPage.url}
                            Component={CustomerCommentApprovalPage}
                        />
                        <AuthorizedRoute path={PageUrl.CustomerAnonymization.url} Component={CustomerAnonymization} />
                        <AuthorizedRoute
                            path={PageUrl.CustomerAnonymizationHistory.url}
                            Component={CustomerAnonymizationHistory}
                        />
                        <AuthorizedRoute path={PageUrl.StoreReturnSearch.url} Component={StoreReturnSearch} />
                        <AuthorizedRoute path={PageUrlYdMp.refund.url} Component={YdRefund} />
                        <AuthorizedRoute path={PageUrlYdMp.labelPrint.url} Component={MpLabelPrint} />
                        <AuthorizedRoute path={PageUrl.rptTopicManagement.url} Component={RptTopicManagement} />
                        <AuthorizedRoute path={PageUrl.storeDeliveryOrders.url} Component={StoreDeliveryOrders} />
                        <AuthorizedRoute path={PageUrl.cookieManagement.url} Component={CookieManagement} />
                        <AuthorizedRoute path={PageUrl.cookieType.url} Component={CookieType} />
                        <AuthorizedRoute path={PageUrl.commentListV2.url} Component={ProductCommentListV2} />
                        <AuthorizedRoute path={PageUrl.digitalCard.url} Component={DigitalCard} />
                        <AuthorizedRoute path={PageUrl.expenseNote.url} Component={ExpenseNote} />
                        <AuthorizedRoute path={PageUrl.cargoPrioritization.url} Component={CargoPrioritization} />
                        <AuthorizedRoute path={PageUrl.orderPrio.url} Component={OrderPrio} />
                        <AuthorizedRoute path={PageUrl.forcePasswordReset.url} Component={CustomerPasswordChange} />
                        <AuthorizedRoute
                            path={PageUrl.globaldatatokenmanagement.url}
                            Component={GlobalDataTokenManagement}
                        />
                        <AuthorizedRoute path={PageUrl.paymentConsolidation.url} Component={PaymentConsolidation} />
                        <AuthorizedRoute path={PageUrl.mobileExpressFraud.url} Component={MobileExpressFraud} />
                        <AuthorizedRoute path={PageUrl.shippingcompanylabel.url} Component={ShippingCompanyLabel} />
                        <AuthorizedRoute path={PageUrl.goalStatusSending.url} Component={GoalStatusSending} />
                        <AuthorizedRoute path={PageUrlRs.pendingShipmentsPage.url} Component={PendingShipmentsPage} />
                        <AuthorizedRoute path={PageUrlRs.fiscalPage.url} Component={FiscalPage} />
                        <AuthorizedRoute path={PageUrl.lostCargo.url} Component={LostCargo} />
                        <AuthorizedRoute path={PageUrl.summary.url} Component={Summary} />
                        <AuthorizedRoute path={PageUrl.summaryV2.url} Component={SummaryV2} />
                        <AuthorizedRoute
                            path={PageUrl.summaryAggregation.netSales.url}
                            Component={NetSales}
                        />
                        <AuthorizedRoute
                            path={PageUrl.summaryAggregation.summaryList.url}
                            Component={SaSummaryList}
                        />
                        <AuthorizedRoute
                            path={PageUrl.summaryAggregation.summaryDetailSearch.url}
                            Component={SaSummaryDetailSearch}
                        />
                        <AuthorizedRoute exact path={PageUrl.jsonTemplate.url} Component={JsonTemplate} />
                        <AuthorizedRoute path={PageUrl.addJsonTemplate.url} Component={AddJsonTemplate} />
                        <AuthorizedRoute path={PageUrl.editJsonTemplate.url} Component={EditJsonTemplate} />
                        <AuthorizedRoute
                            path={PageUrl.storePickupPackageAdmission.url}
                            Component={StorePickupPackage}
                        />
                        <AuthorizedRoute
                            path={PageUrl.cargoReconciliationIFrame.url}
                            Component={CargoReconciliationIFrame}
                        />
                        <AuthorizedRoute path={PageUrl.postCheckoutInsights.url} Component={PostCheckoutInsights} />
                        <AuthorizedRoute path={PageUrl.paylens.url} Component={Paylens} />
                        <AuthorizedRoute path={PageUrl.paylensPayment.url} Component={PaylensPayment} />
                        <AuthorizedRoute
                            path={PageUrl.customerCommunicationPrefrencesReport.url}
                            Component={CustomerCommunicationPrefrencesReport}
                        />
                        <AuthorizedRoute path={PageUrl.etbisReports.url} Component={EtbisReports} />
                        <AuthorizedRoute path={PageUrl.lostCargoReturnPage.url} Component={LostCargoReturnPageLayout} />
                        <AuthorizedRoute
                            path={PageUrl.lostCargoReturnPage.detailUrl}
                            Component={LostCargoReturnDetailPageLayout}
                        />
                        <AuthorizedRoute path={PageUrl.auditLogs.url} Component={AuditLogs} />
                        <AuthorizedRoute
                            path={PageUrl.akbankTransactionStatusList.url}
                            Component={AkbankTransactionStatusList}
                        />
                        <AuthorizedRoute path={PageUrl.cardBalanceInquiry.url} Component={CardBalanceInquiry} />
                        <AuthorizedRoute path={PageUrl.dailyPlanner.url} Component={DailyPlanner} />

                        {/* Studio Routes */}
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.itemAcceptanceCancellation.url}
                            Component={ItemAcceptanceCancellation}
                        />
                        <AuthorizedRoute path={PageUrl.otpPassword.url} Component={OTPPassword} />
                        <AuthorizedRoute
                            path={PageUrl.membershipSmsManagement.url}
                            Component={MembershipSmsManagement}
                        />
                        <AuthorizedRoute path={PageUrl.studioRoutes.planningDetail.url} Component={PlanningDetail} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.planningCreate.url} Component={PlanningDetail} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.planningList.url} Component={PlanningList} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.fileManager.url} Component={FileManager} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.grpcFileManager.url} Component={GRPCFileManager} />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.legacyTransferImport.url}
                            Component={LegacyTransferImport}
                        />
                        <AuthorizedRoute path={PageUrl.studioRoutes.retouch.url} Component={Retouch} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.ipWhiteList.url} Component={IpWhiteList} />
                        <AuthorizedRoute path={PageUrl.studioRoutes.syncTableState.url} Component={SyncTableState} />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiGenerationHistory.url}
                            Component={AIGenerationHistoryPage}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiGenerationModel.url}
                            Component={AIGenerationPage}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiGenerationHanger.url}
                            Component={AIGenerationPage}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiGeneration.url}
                            Component={AIGenerationTypeSelectorPage}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.mannequinEdit.url}
                            Component={MannequinFormWrapper}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.studyoPromptList.url}
                            Component={StudioPromptList}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiStudioAnalytics.url}
                            Component={AIStudioAnalytics}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.productGenerationReport.url}
                            Component={ProductGenerationReport}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.mannequinCreate.url}
                            Component={MannequinFormWrapper}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.backgroundLabelManagement.url}
                            Component={BackgroundLabelManagement}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.aiGenerationTypeManagement.url}
                            Component={AIGenerationTypeManagement}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.addressBarcodeManagement.url}
                            Component={StudioAddressBarcodeManagement}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.addressBarcodeInformation.url}
                            Component={StudioAddressBarcodeInformation}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.productShotHistory.url}
                            Component={ProductShotHistory}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.studioShotReport.url}
                            Component={StudioShotReport}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.studioProductStatusFlowReport.url}
                            Component={StudioProductStatusFlowReport}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.matchingSetPendingReport.url}
                            Component={MatchingSetPendingReport}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.pendingRetouchTransfers.url}
                            Component={PendingRetouchTransfers}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.bulkImageUpload.url}
                            Component={BulkImageUpload}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.rawImageFrameControl.url}
                            Component={RawImageFrameControl}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.batchOutputControl.url}
                            Component={BatchOutputControl}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.batchProcessTracking.url}
                            Component={BatchProcessTracking}
                        />
                        <AuthorizedRoute
                            path={PageUrl.studioRoutes.barcodeProductionHistory.url}
                            Component={BarcodeProductionHistory}
                        />
                        <AuthorizedRoute path={PageUrl.studioRoutes.mannequinList.url} Component={Mannequin} />
                        <AuthorizedRoute
                            exact
                            path={PageUrl.aiPromptManagementS3Test.url}
                            Component={AIPromptS3BrowserTest}
                        />
                        <AuthorizedRoute exact path={PageUrl.s3Browser.url} Component={S3Browser} />
                        <AuthorizedRoute exact path={PageUrl.aiPromptManagement.url} Component={AIPromptManagement} />
                        <AuthorizedRoute path={PageUrl.taskAnalyzer.url} Component={TaskAnalyzer} />
                        <AuthorizedRoute path={PageUrl.customerDiagnostics.url} Component={CustomerDiagnostics} />
                        <AuthorizedRoute path={PageUrl.paymentLogs.url} Component={PaymentLogs} />
                        <AuthorizedRoute
                            path={PageUrl.fastDeliveryCargoManagement.url}
                            Component={FastDeliveryCargoManagement}
                        />
                        <AuthorizedRoute path={PageUrl.redisCacheManagement.url} Component={RedisCacheManagement} />
                        <AuthorizedRoute path={PageUrl.lcwCargoFeeManagement.url} Component={LCWCargoFeeManagement} />
                        <AuthorizedRoute path={PageUrl.noOrderShotSearch.url} Component={NoOrderShotSearch} />
                        <AuthorizedRoute path={PageUrl.mpCargoFeeManagement.url} Component={MPCargoFeeManagement} />
                        <Route path={PageUrl.mpBulkShipmentUpdate.url} exact component={MPBulkShipmentUpdate} />
                        <AuthorizedRoute
                            path={PageUrl.mpPaymentOnDeliveryCommission.url}
                            Component={MPPaymentOnDeliveryCommission}
                        />
                        {/* Role Approval Routes */}
                        <AuthorizedRoute path={PageUrl.cutOff.url} Component={CutOff} />
                        <AuthorizedRoute path={PageUrl.cargoAddressBlocking.url} Component={CargoAddressBlocking} />
                        <AuthorizedRoute path={PageUrl.storeCargoBlocking.url} Component={StoreCargoBlocking} />
                        <AuthorizedRoute path={PageUrl.pendingRoleRequests.url} Component={PendingRoleRequests} exact />
                        <AuthenticatedRoute path={PageUrl.requestRole.url} Component={RequestRole} exact />
                        <AuthenticatedRoute path={PageUrl.requestRoleGuide.url} Component={Home} exact />
                        <AuthenticatedRoute path={PageUrl.myRoleRequests.url} Component={MyRoleRequests} exact />
                        <AuthenticatedRoute
                            path={PageUrl.mobileProductCapture.url}
                            Component={MobileProductCapture}
                            exact
                        />
                        <AuthorizedRoute
                            path={PageUrl.storeManagerStaffPermission.url}
                            Component={StaffPermissions}
                            exact
                        />
                        <AuthorizedRoute
                            path={PageUrl.storeManagerPermissionHistory.url}
                            Component={PermissionHistory}
                            exact
                        />
                        <AuthorizedRoute path={PageUrl.hiddenExcel.url} Component={HiddenExcel} />
                        <AuthorizedRoute path={PageUrl.binNumberManagement.url} Component={BinNumberManagement} />
                        <AuthorizedRoute path={PageUrl.growManagement.url} Component={GrowManagement} />
                        <AuthorizedRoute path={PageUrl.growCategoryRestriction.url} Component={GrowCategoryRestriction} />
                        <AuthorizedRoute path={PageUrl.growWorkingDays.url} Component={GrowWorkingDays} />
                        <AuthorizedRoute path={PageUrl.financeReport.url} Component={FinanceReport} />
                        <AuthorizedRoute
                            path={PageUrl.cargoCompanyDistributionAreas.url}
                            Component={CargoCompanyDistributionAreas}
                        />
                        <AuthorizedRoute path={PageUrl.returnIpLogReport.url} Component={ReturnIpLogReport} />
                        <AuthorizedRoute exact path={PageUrl.retroBoard.url} Component={RetroBoard} />
                        <Route path="*" component={NotFound} exact />
                    </Switch>
                </Suspense>
            </Router>
        </div>
    );
}
